const Sidebar: React.FC = ({ children }) => <div className='sidebar'>{children}</div>;

export default Sidebar;
